/** Google-style week grid: hour rows, today highlight, timed events placed by start/end, click a slot to create. */
import React from 'react';
import { HOUR_PX, DAY_START, DAY_END, addDays, sameDay, evStart, evEnd, isAllDay, fmtTime } from './calUtils';

const HOURS = Array.from({ length: DAY_END - DAY_START }, (_, i) => DAY_START + i);

function EventChip({ e, onOpen }) {
  const s = evStart(e); const en = evEnd(e);
  const top = Math.max(0, (s.getHours() + s.getMinutes() / 60 - DAY_START) * HOUR_PX);
  const h = Math.max(20, ((en - s) / 3600000) * HOUR_PX - 2);
  return (
    <button type="button" onClick={(ev) => { ev.stopPropagation(); onOpen(e); }} data-testid={`cal-event-${e.event_id}`}
      className="absolute left-0.5 right-1 overflow-hidden rounded-md bg-[#039be5] px-1.5 py-0.5 text-left text-[11px] leading-tight text-white shadow-sm transition-opacity hover:opacity-90"
      style={{ top, height: h }}>
      <span className="block truncate font-medium">{e.summary || '(No title)'}</span>
      <span className="block truncate opacity-90">{fmtTime(s)} – {fmtTime(en)}</span>
    </button>
  );
}

export function WeekGrid({ weekStart, events, onSlot, onOpen }) {
  const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
  const today = new Date();
  return (
    <div className="flex min-w-[720px] flex-col" data-testid="calendar-week-grid">
      <div className="grid grid-cols-[56px_repeat(7,1fr)] border-b">
        <div />
        {days.map((d) => (
          <div key={d.toISOString()} className="py-2 text-center">
            <p className={`text-[11px] font-medium uppercase ${sameDay(d, today) ? 'text-[#1a73e8]' : 'text-muted-foreground'}`}>{d.toLocaleDateString([], { weekday: 'short' })}</p>
            <p className={`mx-auto mt-0.5 flex h-10 w-10 items-center justify-center rounded-full text-2xl ${sameDay(d, today) ? 'bg-[#1a73e8] text-white' : ''}`}>{d.getDate()}</p>
            {events.filter((e) => isAllDay(e) && sameDay(evStart(e), d)).map((e) => (
              <button key={e.event_id} type="button" onClick={() => onOpen(e)} className="mx-1 mt-1 block w-[calc(100%-8px)] truncate rounded bg-[#33b679] px-1 text-left text-[11px] text-white">{e.summary}</button>))}
          </div>))}
      </div>
      <div className="grid max-h-[65vh] grid-cols-[56px_repeat(7,1fr)] overflow-y-auto pt-2">
        <div>{HOURS.map((h) => <div key={h} className="relative h-12 pr-2 text-right text-[10px] text-muted-foreground"><span className="-mt-2 block">{h === 12 ? '12 PM' : h > 12 ? `${h - 12} PM` : `${h} AM`}</span></div>)}</div>
        {days.map((d) => (
          <div key={d.toISOString()} className="relative border-l">
            {HOURS.map((h) => <div key={h} className="h-12 cursor-pointer border-b border-border/60 hover:bg-muted/40" onClick={() => { const x = new Date(d); x.setHours(h, 0, 0, 0); onSlot(x); }} data-testid={`cal-slot-${d.getDate()}-${h}`} />)}
            {events.filter((e) => !isAllDay(e) && sameDay(evStart(e), d)).map((e) => <EventChip key={e.event_id} e={e} onOpen={onOpen} />)}
          </div>))}
      </div>
    </div>
  );
}
